module.exports = __webpack_public_path__ + "4bfbc79522e377df005fded507587c2a.svg";